// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueModels from 'vue-models'
import Notifications from 'vue-notification'
import Carousel3d from 'vue-carousel-3d'
import language from './language'

import App from './App'
import router from '@/router'
import store from '@/store'
import moment from 'moment'
import * as VueJsonSchemaForm from 'vue-json-schema-form'
import * as VueGoogleMaps from 'vue2-google-maps'
import GmapCluster from 'vue2-google-maps/dist/components/cluster' // replace src with dist if you have Babel issues
import PrimeVue from 'primevue/config'
import CascadeSelect from 'primevue/cascadeselect'
import InputText from 'primevue/inputtext'
import Calendar from 'primevue/calendar'
import InputNumber from 'primevue/inputnumber'
import Divider from 'primevue/divider'
import Card from 'primevue/card'
import Dropdown from 'primevue/dropdown'
import Button from 'primevue/button'
import Chip from 'primevue/chip'
import ToggleButton from 'primevue/togglebutton'
import MultiSelect from 'primevue/multiselect'
import ScrollPanel from 'primevue/scrollpanel'
import AutoComplete from 'primevue/autocomplete'

// import Multiselect from 'vue-multiselect'

import './assets/scss/theme.scss'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'
import 'primeflex/primeflex.css'
// import 'vue-multiselect/dist/vue-multiselect.min.css'

// Filtrar las advertencias de claves duplicadas
const originalConsoleError = console.error
console.error = (message) => {
  if (message.startsWith('[Vue warn]: Duplicate keys detected')) return
  originalConsoleError(message)
}

Vue.prototype.moment = moment
Vue.prototype._i18n = language
Vue.config.productionTip = false
Vue.config.app = process.env
Vue.use(Carousel3d)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDx4wkeZ-sT6M6IFBdxjispWXMWdnVuxDk',
    libraries: 'places'
  }
})

Vue.component('GmapCluster', GmapCluster)
Vue.use(VueModels, {
  schemaWarnings: false
})
Vue.use(Notifications)
Vue.use(VueJsonSchemaForm.default)
Vue.use(PrimeVue, {ripple: true})
Vue.component('CascadeSelect', CascadeSelect)
Vue.component('InputText', InputText)
Vue.component('Calendar', Calendar)
Vue.component('InputNumber', InputNumber)
Vue.component('Divider', Divider)
Vue.component('Card', Card)
Vue.component('Dropdown', Dropdown)
Vue.component('Button', Button)
Vue.component('Chip', Chip)
Vue.component('ToggleButton', ToggleButton)
Vue.component('MultiSelect', MultiSelect)
Vue.component('ScrollPanel', ScrollPanel)
Vue.component('AutoComplete', AutoComplete)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  language,
  router,
  store,
  template: '<App/>',
  components: { App }
}).$mount()



// WEBPACK FOOTER //
// ./src/main.js